import React from 'react';
import Main from './components/containers/Main';

const ViewOrders = () => <Main />;

export default ViewOrders;
